const e = {
  openProjectEditDialogEvent: "project-edit-dialog-open-event",
  projectEditDialogProjectUpdatedEvent: "project-edit-dialog-project-updated-event"
};
function o(t) {
  window.dispatchEvent(
    new CustomEvent(
      e.projectEditDialogProjectUpdatedEvent,
      {
        detail: t
      }
    )
  );
}
function d(t) {
  window.dispatchEvent(
    new CustomEvent(
      e.openProjectEditDialogEvent,
      {
        detail: t
      }
    )
  );
}
export {
  o as dispatchProjectUpdatedEvent,
  d as openProjectEditDialog,
  e as projectsEditDialogEventKeys
};
